import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import { REGISTRATION_STATUS } from '@root/src/types';
import { capitalizeWords } from '@root/src/utils/gobal';
import EventCategoryList from '@features/eventDetail/components/EventCategoryList';
import EventLine from '@features/eventDetail/components/EventCategoryList/EventLine';
import { selectEventsWithOpenRegCategoriesCount, selectEventsDetailList } from '@features/eventDetail/slices/eventDetailServerSlice';
import { textH3 } from '@features/ui/styles/textStyles';
import { selectSubscriptionFor, selectSubscriptionPack } from '@features/subscriptions/slices/formSubscriptionSlice';
import { selectCurrentUserDetail, selectIsAuthenticated } from '@features/users/slices/userSlice';

const EventAndCategoryList = () => {
  const { t } = useTranslation();

  const events = useSelector(selectEventsDetailList);
  const categoriesCount = useSelector(selectEventsWithOpenRegCategoriesCount);
  const subscriptionPack = useSelector(selectSubscriptionPack);
  const subscriptionFor = useSelector(selectSubscriptionFor);
  const user = useSelector(selectCurrentUserDetail);
  const logged = useSelector(selectIsAuthenticated);

  const userSelected = subscriptionFor ?? user;

  const categoryTitle = logged ? t(`eventSubscription_categoryTitleLogged_${userSelected.gender}.message`, {
    count: categoriesCount,
    firstName: capitalizeWords(userSelected.firstName),
    lastName: capitalizeWords(userSelected.lastName),
    birthYear: userSelected.birthDateObj.year,
  }) : t('eventSubscription_categoryTitle.message', { count: categoriesCount });

  return (
    <>
      {subscriptionPack && (
        <StyledTitle>
          {categoryTitle}
        </StyledTitle>
      )}

      {events.map(event => (event && (
        <>
          <EventLine
            eventId={event._idMso}
          />
          {
            event.status?.registration === REGISTRATION_STATUS.OPEN
              ? <EventCategoryList eventId={event._idMso} />
              : <StyledText>{t('serieSubscription_eventRegCloseIntro.message')}</StyledText>
          }
        </>
      )))}
    </>
  );
};

export default EventAndCategoryList;

const StyledTitle = styled.h3`
  ${textH3};
  margin-bottom: 20px;
`;
const StyledText = styled.h3`
  ${textH3};
  margin-top: 20px;
`;
